<template>
  <div class="chat-container">
    <van-popup
      v-model:show:="show"
      position="left"
      :style="{ width: '80%', height: '100%',}"
      >
      <div style="display: flex;flex-direction: column;margin: 20px;height: 100%;">
        <div style="height: 50px;background-color:#E8F7FF;display: flex;align-items: center;justify-content: start;border-radius: 10px;padding-left: 10px;border: 1px solid #9FD4FD;color:#165DFF;font-weight:bold;flex:0.2;" @click="new_chat">
          <van-icon name="plus" size="1em" style="padding-right: 10px;" />新建会话
        </div>
        <div class="chatboxhistory" style="margin-top: 20px;min-height: 300px;flex:3;">
          <div class="boxtitle">历史记录</div>
          <ul>
            <li v-for="(item,index) in items" :key="index" :class="{selected:itemsSelectedID==item.requestId}" @click="toggleSelect(item)">{{item.title}}</li>
            <li class="lastitem" @click="show_rec_history">查看所有</li>
          </ul>
        </div>
        <div style="display: flex;flex:0.5;flex-direction: column;">
          <van-pagination v-model="currentPage" :total-items="pageCount" 
          :items-per-page="pageSize"
          mode="simple" style="font-size: 0.8em;" @change="pageChange" />
        </div>
        <div style="display: flex;flex:0.5;flex-direction: row;">
          <div style="display: flex;flex:1;">
          <van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            @select="onSelect"
            placement="top">
            <template #reference>
              <van-button type="primary" style="height: 32px;width: 80px;background:#f2f3f5;border: none;color: #165DFF;font-size: 0.9em;">{{lineName}}</van-button>
            </template>
          </van-popover>
          </div>
        </div>
      </div>
      </van-popup>
    <div class="messages" ref="messagesContainer">
      <div v-for="(message, index) in messages" :key="index"  class="message-item">
         <!-- 使用 v-html 来渲染 HTML 内容 -->
        <div v-html="message.htmlContent" :id="message.key" class="message" :class="{ 'is-self': message.isSelf }"  @click="open"></div>
      </div>
      <div class="dot_box" v-show="showddd">
        <div class='dot dot1'></div>
        <div class='dot dot2'></div>
        <div class='dot dot3'></div>
      </div>
      <div class="rec_history" v-if="is_show_rec_history">
        <van-list
        v-model="rec_history_loading"
        :finished="rec_history_finished"
        finished-text="没有更多了"
        @load="rec_history_onload"
        >
          <van-cell v-for="(item,index) in rec_history_list" :key="index" :title="item.title" :label="item.createdAt" @click="chat_history_view(item)" >
            <template #right-icon>
              <van-icon name="delete" color="#6b7785" class="search-icon" @click.stop="rec_history_del(item)" />
            </template>
          </van-cell>
        </van-list>
        
      </div>
      <div id="go_bottomopopo" class="row_bottom"></div>
    </div>
    <div class="input-area">
      <div class="oper">
        <van-icon name="add" size="42"  color="#2d8cf0" class="oper_icon" @click="showLeft" />
      <input v-model="inputText" type="text" :placeholder="showddd?'AI正在应答・・・':'输入您的问题・・・'"  @keyup.enter="submit" class="oper_input" :disabled="showddd?true:false" />
      <van-button class="button_send"  :text="showddd?'':'发送'" type="primary" @click="submit" >
      <template #icon>
        <van-icon :name="showddd?'stop-circle':''" size="1.6em"/>
      </template>
      </van-button>
      </div>
      <div class="notice">内容由 AI 大模型生成，请仔细甄别。</div>
    </div>
     
    <!-- 列表组件 -->
    <list-content
      ref="listContent"
    ></list-content>
  </div>
</template>

<script>
import ListContent from "@/components/common/listContent";
import { getAISign } from '../../utils/lib/sign.js'
import marked from 'marked'
import { uuid } from 'vue-uuid'
import store from '../../store'
import { wsurl } from "../../../public/config.json";
import MessageQueue from "../../utils/lib/messagequeue2"
import Typewriter from "typewriter-effect/dist/core"
const ChatMessageQueue = new MessageQueue()
let cur_typewriter = null
export default {
  data() {
    return {
      inputText: '',
      messages: [
        // 预设一些消息
        // { htmlContent: '<strong>你好，我是你的助手。</strong>', isSelf: false },
      ],
      ws: null,
      key: '',
      userGuid: store.state.user.userGuid,
      tkn: store.state.user.token,
      user_maxtokens:store.state.user.maxtokens,
      vertical: "3",//线路
      show: false,
      items: [],//历史记录
      itemsSelectedID: '',
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '线路一', label: '3',icon:'success',className:'icon_skin'}, { text: '线路二', label: '1' }],
      lineName: '线路一',
      currentPage: 1,
      pageSize:10,
      pageCount: 0,
      showddd: false,
      rec_history_loading: false,
      rec_history_finished: false,
      rec_history_list: [],
      rec_pageSize:20,
      rec_Count: 0,
      rec_currentPage: 1,
      is_show_rec_history: false,

      is_timer_processing: false,
      typeIntervalId:0,
    };
  },
  components: {
    ListContent,
  },
  beforeDestroy() {
    clearInterval(this.typeIntervalId)
  },
  created() {
        console.log('ai chat create==>')
        this.new_chat()
  },
  methods: {
    show_rec_history() { 
      this.messages=[]
      this.itemsSelectedID = ''
      this.show = false
      this.is_show_rec_history = true
    },
    rec_history_del(item) { 
      console.log(item)
      let args = {
        requestid:item.requestId
      }
      try {
           this.$http.reqDeleteOneHistoryRec(args).then(res => {
              console.log(res)
             if (res.rtncode == 1) {
               if (res.rltcode == 1) {
                 console.log(res.rltdesc)
                 let indexToRemove = this.rec_history_list.findIndex(p => p.requestId === item.requestId)
                 console.log(indexToRemove)
                 if (indexToRemove !== -1) { 
                  this.rec_history_list.splice(indexToRemove, 1);
                  this.$notify({ type: 'success', message: '删除成功' });
                 }
                 return
               } else {
                 console.log(res.rltdesc)
                 this.$notify({ type: 'danger', message: res.rltdesc });
                 return
               }
             } else { 
               console.log(res.rtndesc)
               this.$notify({ type: 'danger', message: res.rtndesc });
               return
             }
              
          })
      } catch (e) {
        console.log(e)
      }
    },
    rec_history_onload() { 
      this.rec_history_list_get()
       
    },
    new_chat_hellow(){
      var str = `<chat_sys><sys_txt>Hi,我是税务AI助手 <span style="color:red;font-weight:bold;">小智</span>，很高兴遇见你。<p>我专注于税务领域，提供安全、有帮助、准确的税务相关信息。</p><p>我的设计旨在为用户提供专业的税务咨询服务。</p><p>如果您有任何关于税务的问题，欢迎随时向我咨询。</p></sys_txt></chat_sys>`
      let txt = {key:"000001",htmlContent: str, isSelf: false }
      this.messages.push(txt)
    },
    new_chat() {
      console.log('new_chat====>');
      this.messages = []
      this.new_chat_hellow()
      ChatMessageQueue.clear()
      this.is_timer_processing = false
      this.itemsSelectedID = ''
      this.show = false
      this.is_show_rec_history=false
    },
    onSelect(action) {
       this.$notify({
        color: "#fff",
        background: "#57A9FB",
        message: action.text,
        duration: 3000,
       });
      this.vertical = action.label
      this.lineName=action.text
      //取消所有图标
      this.actions.forEach(item => { 
        item.icon = ''
        item.className=''
      })
      //选中当前item冰设置图标
      action.icon = 'success'
      action.className='icon_skin'
    },
    open(value) {
            let selector = value.srcElement
            let text = value.srcElement.innerHTML
            let strdocid = selector.id
            // console.log(strdocid)
            // console.log(text)
            // console.log(selector.tagName)
            let row = {
                docid: strdocid
            }

            if (selector.tagName === "ITEM") {
                if (selector.id) {
                  this.enterDetail(strdocid)
                } else {
                    return
                }
            }else if (selector.tagName === "RECOMMEND"){
                if (selector.id) {
                  this.enterDetail(strdocid)
                } else {
                    return
                }
            }
        },
    enterDetail(strid) {
      //this.$refs.listContent.showDetailPopup= true

      let doc = {
        strdocid: strid,
        docid: "",
        h1hit:[],
        chit:[],
        chitseq:[],
        cutwords: [],
      };

      this.$refs.listContent.getDetail(doc)
    },
    disconnect() { 
      console.error('WebSocket close by user stop');
      if (this.ws !== null) {
          this.ws.close();
          this.ws = null;
      }
      ChatMessageQueue.clear()
      this.is_timer_processing = false
      this.key = ''
      this.showddd = false
      clearInterval(this.typeIntervalId)
      if (cur_typewriter) { 
        cur_typewriter.stop()
      }
      this.rec_history_list = []
    },
    submit() {
      this.is_show_rec_history=false
      if (!this.showddd) {
        this.connect()
      } else { 
        this.disconnect()
        
      }
      
    },
    tt2(typewriter, txt) {
      typewriter.typeString(txt).start()
    },
    new_typewriter(element) {
      cur_typewriter = new Typewriter(element, {
          loop: false,
          delay: 75,
      });
      return cur_typewriter;
    },
    typeMessage(element) {
      console.log("start type Message")

      var tw = this.new_typewriter(element)

      let intervalId = setInterval(() => {
          let msg = ChatMessageQueue.dequeue()
          if (msg) {
              this.tt2(tw, msg)
          }
      }, 1000);
      this.typeIntervalId = intervalId
      this.is_timer_processing = true

    },
    sendMessage() {
      if (this.inputText) {
        const safeHtmlContent = this.makeHtmlSafe(this.inputText);
        let txt = {key:"000000",htmlContent: safeHtmlContent, isSelf: true }
        this.messages.push(txt)
        this.key = uuid.v1()
        
        if (this.ws !== null && this.ws.readyState === WebSocket.OPEN) {
          var args = {
            model: Number(this.vertical),
            question: this.inputText,
            request_id: this.itemsSelectedID
          }
          console.log(args)
          this.ws.send(JSON.stringify(args));
          this.inputText = ''
          this.showddd = true
          this.scrollToBottom();
        } else {
          //重连
          this.disconnect()
          this.connect()
        }
        
      } else { 
        console.log('请输入内容==>')
        return
      }
    },
    connect() {
      console.log("connecting to server")
      this.rec_history_list = []
      ChatMessageQueue.clear()
      var salt = parseInt(Math.random() * (54425) + 11111, 10);
      salt = salt.toString();
      var timestamp = Math.round(new Date().getTime() / 1000)
      timestamp = timestamp.toString()
      console.log(salt+"|"+timestamp)
      console.log(this.userGuid+"|"+this.tkn)
      var sign = getAISign(this.userGuid,this.tkn,salt,timestamp,"2")
      console.log("sign===>"+sign)

      if (this.ws === null) {
          this.ws = new WebSocket(wsurl+'/stream/chat?sign='+sign+'');
          this.ws.onopen = this.onOpen;
          this.ws.onmessage = this.onMessage;
          this.ws.onclose = this.onClose;
          this.ws.onerror = this.onError;
      } else {
          console.log("connect is going==>")
          console.log("send message===>")
          this.sendMessage()
      }
    },
    onOpen(event) {
      console.log('WebSocket connection opened:', event);
      this.sendMessage()
    },
    onMessage(event) {
      console.log('Message received from server:', event.data);
      let data = JSON.parse(event.data)
      this.itemsSelectedID = data.request_id
      let cur = this.messages.find(item => item.key === this.key)
      //console.log(cur)
      var element = document.getElementById(this.key)
       if (data.finish_reason == 'error') {
          let txt = {key:"000999",htmlContent: data.message, isSelf: false }
          this.messages.push(txt)
          this.disconnect()
          return
      }
      if (cur) {
        if (!this.is_timer_processing) {
          //拉起timer开始打印
          this.typeMessage(element)
        }
        if (data.finish_reason == 'stop') {
          ChatMessageQueue.clear()
          clearInterval(this.typeIntervalId)
          cur.htmlContent=''
          cur.htmlContent = marked.parse(data.message)
        } else if (data.finish_reason == 'policy') {
          this.showddd = false
          if (data.recommend) {
            let recommendStr=''
            recommendStr+=` <div class="recommend_txt" style="color:#00B42A">相关政策</div>`
            for (var item of data.recommend){
                recommendStr+=`<recommend id=`+item.doc_id+` class="suggest_item">`+item.title+`</recommend>`
          }
          var str = `<div class="suggest_box">` + recommendStr + `</div>`
          cur.htmlContent += str
          }
          
        } else if (data.finish_reason == 'recommend') {
          this.showddd = false
          if (data.recommend) {
            let recommendStr=''
            recommendStr+=` <div class="recommend_txt" style="color:#165DFF">官方解答</div>`
            for (var item of data.recommend){
                recommendStr+=`<recommend id=`+item.doc_id+` class="suggest_item">`+item.title+`</recommend>`
          }
          var str = `<div class="suggest_box">` + recommendStr + `</div>`
          cur.htmlContent += str
          }

          clearInterval(this.typeIntervalId)
          this.is_timer_processing = false
          
        } else { 
          if (this.vertical == '4') {
            cur.htmlContent = data.message
          } else { 
            // cur.htmlContent += data.message
            ChatMessageQueue.enqueue(data.message)
          }
          //console.log('add-->')
          
        }
      } else { 
        console.log('===============>')
        let msg = {
          key:this.key,
          htmlContent:'',
          isSelf: false
        }
        //创建消息载体
        this.messages.push(msg)
        ChatMessageQueue.enqueue(data.message)
        console.log('new-->')
      }
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    onClose(event) {
      console.log('WebSocket connection closed:', event);
      clearInterval(this.typeIntervalId)
      if (cur_typewriter) { 
        cur_typewriter.stop()
      }
      this.ws = null;
      this.key = ''
      this.showddd = false
      
    },
    onError(event) {
      console.error('WebSocket error observed:', event);
      clearInterval(this.typeIntervalId)
      if (cur_typewriter) { 
        cur_typewriter.stop()
      }
      this.ws = null;
      this.key = ''
      this.showddd=false
    },

    // 示例函数，你需要实现自己的 HTML 清理逻辑
    makeHtmlSafe(html) {
      // 使用 DOMPurify 或类似库来清理 HTML
      //return DOMPurify.sanitize(html);
      return html
    },
    scrollToBottom() {
      console.log('scroll to go_bottomopopo====>');
      var element = document.getElementById('go_bottomopopo');
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
      
    },
    showLeft() { 
      this.show = true
      this.chat_history()
    },
    toggleSelect(item) { 
      this.itemsSelectedID = item.requestId
      this.chat_history_view(item)
      console.log(item)
      this.show=false
    },
    pageChange() { 
      this.chat_history()
    },
    rec_history_list_get() { 
      var args = {
        page: this.rec_currentPage,
        pagesize:this.rec_pageSize,
      }
      console.log(args)
      try {
           this.$http.reqChatHistory(args).then(res => {
              this.rec_Count = res.total
              console.log(res)
              if (res.data.length > 0) {
                this.rec_history_list.push(...res.data)
                this.rec_history_loading = false
                if (this.rec_currentPage * this.rec_pageSize >= this.rec_Count) { 
                  this.rec_history_finished=true
                }
                this.rec_currentPage += 1
              }
              
          })
      } catch (e) {}
    },
    chat_history() {
      var args = {
        page: this.currentPage,
        pagesize:this.pageSize
      }
      
      try {
           this.$http.reqChatHistory(args).then(res => {
              console.log(res)
              if (res.data.length > 0) {
                this.items = res.data
                this.pageCount = res.total
                // this.rec_history_list=res.data
                // this.rec_history_loading = false
                // this.rec_history_finished=true
              }
          })
      } catch (e) {}

    },
    chat_history_view(msg) {
      console.log('chat_history_view',msg)
      this.messages = []
      this.is_show_rec_history=false
      var args = {
        requestId:msg.requestId
      }
      try {
           this.$http.reqChatHistoryView(args).then(res => {
              console.log(res)
              if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                  let user = {key:res.data[i].requestId,htmlContent: res.data[i].question, isSelf: true }
                  this.messages.push(user)
                  let sys = { key: res.data[i].requestId, htmlContent: marked.parse(res.data[i].content), isSelf: false }
                  this.messages.push(sys)
                }
              }
          })
      } catch (e) {}

    },
  }
};
</script>

<style lang="less">
.rec_history{
  .van-cell::after {
    border: none;
  }
  .search-icon {
    font-size: 16px;
    line-height: inherit;
    width:10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}


.chatboxhistory{
  ul {
    list-style-type: none; /* 移除默认的列表符号 */
    padding: 0; /* 移除默认的内边距 */
    font-size:0.9em;
    margin-left:20px;
    

    li {
    border-left: 2px solid #e5e6eb; /* 灰色左边框 */
    padding-left: 20px; /* 内边距，使文本与边框保持一定距离 */
    cursor: pointer; /* 鼠标悬停时显示手形图标 */
    transition: border-color 0.3s; /* 平滑过渡效果 */
    line-height: 30px;
    text-overflow:ellipsis;
    white-space: nowrap;
    overflow: hidden;
    
    }
    li.selected {
      border-left-color: #165DFF; /* 选中时蓝色边框 */
      color:#165DFF;
      font-weight:bold;
    }
    .lastitem{
      border-left: 2px dotted #a0b0fe; /* 灰色左边框 */
      font-size: 0.9em;
      color:#a0b0fe;
    }
  }
  .boxtitle{
    margin-left:20px;
    margin-bottom:20px;
  }
  
}
.icon_skin{
  color: #165DFF;
}



/* 设置一个名为section的计数器 */
body {
  //counter-reset: section;
}

.chat-container {
  position: relative;
  height: 85vh;
  overflow: hidden;
  background-color: white;
}

.messages {
  display: flex;
  flex-direction: column;
  padding: 10px;
  overflow-y: auto;
  height: calc(100% - 80px); /* 减去输入框的高度 */
  line-height: 2;/*行间距是字体大小的2倍 */
  
  ol {
      list-style-position: inside;
  }

  ul {
      list-style-position: inside;
  }

  li {
      min-width: 3em;
      //counter-increment: section;/* 每个li元素都增加计数器的值 */
      padding-top:10px;
  }

  li p::before {
    //content: counter(section) ". ";/* 设置p元素的内容，包括计数器的值 */
    margin-right: 5px; /* 可选，增加一些右外边距 */

  }
}

.message-item {
  margin-bottom: 10px;
  display: flex; /* 使消息项成为flex容器 */
  align-items: flex-start; /* 垂直对齐消息文本 */
}

.message {
  padding: 5px;
  border-radius: 10px;
  background-color: #ffffff;
  /* max-width: 95%; */
  word-wrap: break-word; /* 允许长单词换行 */
  font-size: 0.9em;
}

.message.is-self {
  margin-top:20px;
  background-color: #165DFF;
  color:white;
  margin-left: auto; /* 将消息推向右侧 */
  font-size: 0.9em;
}

.input-area {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5px;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  height: 80px; /* 固定输入框的高度 */
  flex-direction: column;
  .oper{
    display:flex;
    width: 100%;
    height: 60px;
    flex-direction:row;
    align-items: center;
    .oper_icon{
      background-color: white;
      clip-path: circle(49% at 49% 49%);
    }
    .oper_input{
      margin-left: 5px;
      height: 20px;
      font-size:0.8em;
    }
    .oper_input:disabled{
      margin-left: 5px;
      height: 20px;
      background-color: #f2f3f5;
      font-size:0.8em;
    }
  }
  .notice{
    display: flex;
    font-size: 0.8em;
    height: 30px;
    width: 100%;
    align-items: center;
    color:#4e5969;
    justify-content: center;
  }
}

input[type="text"] {
  flex: 1;
  padding: 10px;
  // margin-right: 10px;
  border-radius: 10px;
  border: none;
}

.button_send {
  margin-left: 5px;
  border-radius: 10px;
  border: none;
  background-color: #2d8cf0;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
}

/* scrollto */
.row_bottom {
    display: flex;
    height: 5px;
    line-height: 6px;
    flex-direction: column;
    /*background-color: rgb(255, 248, 233);*/
    background-color: white;
    justify-items: center;
    width: 100%;
    align-items: center;

}

/* 推荐问题 */
.recommend_txt{
    display: flex;
    padding-left:0px;
    font-weight: bold;
}

.suggest_box {
    display: flex;
    flex-direction: column;
    width: auto;
    padding-top:10px;
    
}
.suggest_item {
    // display: flex;
    border: 1px solid #d8d8d8;
    width: auto;
    height: auto;
    justify-content: left;
    align-items: center;
    margin: 10px 10px;
    border-radius: 10px;
    padding:10px 10px;
    /* 添加圆角 */
    box-shadow: 0px 1px 1px 0px #f2f3f5;
    cursor:pointer;
    background-color: #f2f3f5;
    sr{
      
    }
}

.link {
  color: blue;
  cursor: pointer;
  display: inline;
}

.dot_box {
        display: flex;
        flex-direction: row;
        margin-left: 10px;
        margin-top: 10px;
        background-color: #f7f8fa;
        height: 20px;
        width: 80px;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
    }

/* 将动画应用于类名为'dot'的元素 */
.dot {
  width: 10px;
  /* 圆点的宽度 */
  height: 10px;
  /* 圆点的高度 */
  border-radius: 50%;
  /* 设置为圆形 */
  
  
  display: flex;
  margin-right: 10px;
}
.dot1{
  /* 应用动画，持续时间2秒，无限循环 */
  animation: pulse 2.1s infinite;
  background-color: black;
}
.dot2{
  animation: pulse 2.2s infinite;
  background-color: red;
}
.dot3{
  animation: pulse 2.3s infinite;
  background-color: green;
}

/*ddd*/
@keyframes pulse {
    0% {
        transform: scale(1);
        /* 开始时为原始大小 */
        opacity: 1;
        /* 开始时完全可见 */
    }

    50% {
        transform: scale(0.5);
        /* 缩放到一半大小 */
        opacity: 0.7;
        /* 透明度降低 */
    }

    100% {
        transform: scale(1);
        /* 结束时恢复原始大小 */
        opacity: 1;
        /* 结束时恢复完全可见 */
    }
}

</style>